import Button from '@components/Button';
import Row from '@components/Row';
import styled from '@emotion/styled';
import Add from '@icons/Add';
import { Link } from '@router/Link';

function ExternalCouponFragment() {
  return (
        <Container>
            <Link activityName='NewGiftBottomSheet'
                  activityParams={{}}>
                <Button fullWidth>
                    <Row spacing={4}>
                        <Add size={22}/>
                        새 쿠폰 등록하기
                    </Row>
                </Button>
            </Link>
        </Container>
  );
}

const Container = styled.div`
    padding: 36px 20px;
`;

export default ExternalCouponFragment;
